// Issues raised from an activity — the rules both apps' Activities surfaces
// share.

import type { IConfigArea, IIssue, IProfession } from '../../trusstor/index.js';
import type { ISchedulerTask } from '../interfaces/IScheduler.js';
import { toIssueLocation } from './issueLocation.js';

/**
 * Whether an issue may be raised against a task: a committed field task only.
 * An uncommitted task has no activity in Trusstor for the issue to link to,
 * and an administrative one never does (the server answers 400 for both).
 */
export function mayRaiseIssueOn(
  task: Pick<ISchedulerTask, 'kind'> | undefined,
  activityStatus: string | undefined,
): boolean {
  return task !== undefined && activityStatus !== undefined && task.kind !== 'administrative';
}

/**
 * The issue a manager raises by rejecting an area submitted for review (area
 * review stage spec, ruling 5): the reason IS the issue, as in Trusstor —
 * linked to the task, of its profession, at the area.
 */
export function areaRejectionIssue(
  description: string,
  task: Pick<ISchedulerTask, 'id' | 'profession'>,
  zoneId: string,
  areas: readonly IConfigArea[],
  professions: readonly IProfession[],
): Partial<IIssue> {
  const area = areas.find((a) => a.areaId === zoneId);
  return {
    description,
    taskId: task.id,
    profession: professions.find((p) => p._id === task.profession?.professionId),
    locations: area ? [toIssueLocation(area)] : [],
  };
}
